/**
 Copyright (C) 2022 北大英华版权所有。 
  
  文件名：6个看板
  文件功能描述：6个看板API
  
  创建标识：zhangjiaojiao 20230221
  
  修改标识：
  修改描述：
*/


// 统一请求路径前缀在libs/axios.js中修改
import {
    getRequest,
    postRequest,
    postRequest2,
    postRequest3,
    getRequestBlob
} from '@/libs/request';
// const standGateway = 'law-admin/'
// const standGateway = 'law-api/';
const standGateway = '/';

// 反馈看板---------
// 反馈管理列表
export const feedBackList = (params) => {
    return getRequest(standGateway + 'law/info/feedBack-list', params)
}
// 反馈保存
export const postFeedBack = (params) => {
    return postRequest2(standGateway + 'law/info/feedBack', params)
}
// 反馈管理 类型

export const ByFieldType = (params) => {
    return postRequest2(standGateway + 'search/items', params)
}

// 反馈下载
export const getBackDownload = (id) => {
    return getRequestBlob(standGateway + `law/info/download/attach/${id}`)
}

// 辅助功能看板-------
// 辅助功能 附件上传
export const postUpLoadFileAPI = params => {
    return postRequest3(standGateway + '/law/info/uploadFile', params)
}


// 浏览记录看板-------
// 浏览记录列表
export const getLogList = (params) => {
    return getRequest(standGateway + `law/log/list`, params)
}
// 新增浏览日志
export const postLogAdd = (params) => {
    return postRequest2(standGateway + 'law/log/add', params)
}
// 获取浏览次数
export const getLogViews = (lawId) => {
    return getRequest(standGateway + `law/log/views/${lawId}`)
}
// 浏览记录删除
export const getLogDl = (params) => {
    return getRequest(standGateway + `law/log/dl`, params)
}

// 我的收藏看板------
// 收藏列表
export const getCollectList = (params) => {
    return getRequest(standGateway + `law/info/collect/list`, params)
}
// 取消收藏
export const getCollectDl = (id) => {
    return getRequest(standGateway + `law/info/collect/dl/${id}`)
}

// 变迁管理看板------
// 变迁管理列表
export const postChangeList = (params) => {
    return postRequest2(standGateway + `law/group/list`, params)
}
// 附件下载
export const getChangeAttach = (id) => {
    return getRequestBlob(standGateway + `law/group/download/attach/${id}`)
}

// 通过id 查询法律法规名称
export const getFindTitleById = (params) => {
    return getRequest(standGateway + `article/findTitleById/`,params)
}




